import React, { useState } from 'react';
import styled from 'styled-components';
import CloseButton from './CloseButton';
import HighlightText from './HighlightText';

const TreeSearchWrap = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: 15px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 999;
  overflow-y: scroll;
`;

const TreeSearchInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 380px;
  background-color: #fff;
  padding: 30px 10px 10px;
  box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
`;

const TreeSearchClose = styled.div`
  position: absolute;
  top: 15px;
  right: 15px;
`;

const TreeSearchTitle = styled.h1`
  font-size: 1.2rem;
  color: #333;
  font-weight: 700;
  margin: 0 0 10px;
`;

const TreeSearchInput = styled.input`
  font-size: 1rem;
  width: 100%;
  color: #333;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 5px;
`;

const TreeSearchResult = styled.div`
  padding: 15px 10px;
  border-top: 1px solid #ccc;
  cursor: pointer;

  &:hover {
    background-color: #f7f7f7;
  }

  h2, h3, h4 {
    font-weight: 400;
  }

  h2 {
    font-size: 1em;
    color: #aaa;
    margin: 0 0 0;
  }

  h3 {
    font-weight: 700;
    font-size: 1.2em;
    margin: 0 0 0;
  }

  h4 {
    font-size: 1em;
    margin: 0 0 0;
  }

`;

const TreeSearch = (props) => {
  const [searchTerm, setSearchTerm] = useState('');
  const { treeSearch, setSelectedTree, closeSearch } = props;
  let filteredTrees = [];

  if (searchTerm.length > 0) {
    filteredTrees = treeSearch.search(searchTerm);
  } else {
    filteredTrees = [];
  }

  const selectTree = (treeKey) => {
    setSelectedTree(treeKey);
    closeSearch();
  };

  const highlightText = (text) => (
    <HighlightText
      text={text}
      highlight={searchTerm}
      style={{
        display: 'inline-block',
        fontWeight: 900,
        backgroundColor: '#eee',
        color: '#000',
      }}
    />
  );

  return (
    <TreeSearchWrap>
      <TreeSearchInner>
        <TreeSearchClose>
          <CloseButton onClick={e => closeSearch()} />
        </TreeSearchClose>
        <TreeSearchTitle>Search Trees</TreeSearchTitle>
        <TreeSearchInput type="text" value={searchTerm} onChange={e => setSearchTerm(e.target.value)} placeholder="Enter name or tree number..." />
        {filteredTrees.map(tree => (
          <TreeSearchResult key={tree.key} onClick={e => selectTree(tree.key)}>
            <h2>{highlightText(`${tree.side} ${tree.number}`)}</h2>
            <h3>{highlightText(tree.plaque)}</h3>
            <h4>{highlightText(tree.fullName)}</h4>
          </TreeSearchResult>
        ))}
      </TreeSearchInner>
    </TreeSearchWrap>
  );
};

export default TreeSearch;
